import { render } from "./mainFooter.vue?vue&type=template&id=7e74c872&scoped=true"
import script from "./mainFooter.vue?vue&type=script&lang=js"
export * from "./mainFooter.vue?vue&type=script&lang=js"

import "./mainFooter.vue?vue&type=style&index=0&id=7e74c872&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e74c872"]])

export default __exports__